import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'

import {App} from './boot/components/App.tsx'
import {InstallPromptListener} from './boot/components/InstallPromptListener.tsx'
import './boot/utils/stats.ts'

const consoleError = console.error
console.error = (msg, ...args) => {
  if (/server-side rendering/.test(msg)) {
    return
  }
  consoleError(msg, ...args)
}

if (!window.verticaltopo) {
  window.verticaltopo = {}
}
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault()
  window.verticaltopo.beforeinstallprompt = event
})

const root = createRoot(
  document.getElementById('root') as HTMLElement,
)

root.render(
  <StrictMode>
    {/* The PromptListener MUST be registered has soon as possible Because the event `beforeinstallprompt` is sent once at startup */}
    <InstallPromptListener/>
    <App/>
  </StrictMode>,
)
